import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { useValidationService } from "../../../../../services/hooks/index.js";
import { Dialog, DialogContent } from "../../../../../Dialog/index.js";
import { Button } from "../../../../../Button/index.js";
import { FileInput } from "../../../../index.js";
import { useForm } from "../../hooks/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const AddFileDialog = (t0)=>{
    const $ = c(42);
    const { open, onClose, addFile } = t0;
    const [file, setFile] = useState();
    const validator = useValidationService();
    let t1;
    if ($[0] !== file) {
        t1 = {
            file
        };
        $[0] = file;
        $[1] = t1;
    } else t1 = $[1];
    const allValues = t1;
    let t2;
    if ($[2] !== validator) {
        t2 = validator.required();
        $[2] = validator;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== validator) {
        t3 = validator.sizeLimit("\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B pdf, doc(x), xls(x), csv \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 10\u041C\u0411", {
            field: "file",
            sizeLimit: 10
        });
        $[4] = validator;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== validator) {
        t4 = validator.requiredIfFile("\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B pdf, doc(x), xls(x), csv \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 10\u041C\u0411", {
            field: "file",
            fileTypes: [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "text/csv",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel"
            ]
        });
        $[6] = validator;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
        t5 = {
            file: [
                t2,
                t3,
                t4
            ]
        };
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const fieldValidators = t5;
    const { errors, touched, validateField, hasValidationErrors, showError } = useForm(allValues, fieldValidators);
    let t6;
    if ($[12] !== showError || $[13] !== validateField) {
        t6 = (value)=>_async_to_generator(function*() {
                setFile(value);
                yield validateField("file", value);
                showError("file");
            })();
        $[12] = showError;
        $[13] = validateField;
        $[14] = t6;
    } else t6 = $[14];
    const handleChangeFileInput = t6;
    let t7;
    if ($[15] !== addFile || $[16] !== file || $[17] !== onClose) {
        t7 = ()=>{
            onClose();
            if (file) addFile(file);
        };
        $[15] = addFile;
        $[16] = file;
        $[17] = onClose;
        $[18] = t7;
    } else t7 = $[18];
    const handleSubmit = t7;
    let t8;
    if ($[19] !== onClose) {
        t8 = /*#__PURE__*/ jsx(Button, {
            variant: "tertiaryLight",
            size: "large",
            onClick: onClose,
            children: "Отменить"
        });
        $[19] = onClose;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== hasValidationErrors) {
        t9 = /*#__PURE__*/ jsx(Button, {
            type: "submit",
            variant: "primary",
            size: "large",
            disabled: hasValidationErrors,
            children: "Добавить"
        });
        $[21] = hasValidationErrors;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== t8 || $[24] !== t9) {
        t10 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t8,
                t9
            ]
        });
        $[23] = t8;
        $[24] = t9;
        $[25] = t10;
    } else t10 = $[25];
    const t11 = touched.file && !!errors.file;
    const t12 = touched.file ? errors.file : void 0;
    let t13;
    if ($[26] !== file || $[27] !== handleChangeFileInput || $[28] !== t11 || $[29] !== t12) {
        t13 = /*#__PURE__*/ jsx(FileInput, {
            fullWidth: true,
            required: true,
            label: "\u0424\u0430\u0439\u043B",
            value: file,
            placeholder: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B pdf, doc(x), xls(x), csv \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 10\u041C\u0411",
            onChange: handleChangeFileInput,
            error: t11,
            errorText: t12
        });
        $[26] = file;
        $[27] = handleChangeFileInput;
        $[28] = t11;
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== onClose || $[32] !== t10 || $[33] !== t13) {
        t14 = /*#__PURE__*/ jsx(DialogContent, {
            title: "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u0430",
            onClose: onClose,
            actions: t10,
            children: t13
        });
        $[31] = onClose;
        $[32] = t10;
        $[33] = t13;
        $[34] = t14;
    } else t14 = $[34];
    let t15;
    if ($[35] !== handleSubmit || $[36] !== t14) {
        t15 = /*#__PURE__*/ jsx("form", {
            onSubmit: handleSubmit,
            children: t14
        });
        $[35] = handleSubmit;
        $[36] = t14;
        $[37] = t15;
    } else t15 = $[37];
    let t16;
    if ($[38] !== onClose || $[39] !== open || $[40] !== t15) {
        t16 = /*#__PURE__*/ jsx(Dialog, {
            open: open,
            onClose: onClose,
            children: t15
        });
        $[38] = onClose;
        $[39] = open;
        $[40] = t15;
        $[41] = t16;
    } else t16 = $[41];
    return t16;
};
export { AddFileDialog };
